import { DataTable, createColumnHelper } from "@gigpro/ui/DataTable";
import { formatDateTime, browserTimezone } from "@gigpro/utils/datetime";
import type { UserNote } from "@sidegigllc/api/client";
import { useQuery } from "@tanstack/react-query";
import { notesQuery } from "./queries";

const columnHelper = createColumnHelper<UserNote>();

const columns = [
  columnHelper.accessor("created_by_user", {
    header: "Author",
    cell: ({ getValue }) => `${getValue().first_name} ${getValue().last_name}`,
  }),
  columnHelper.accessor("created_ts", {
    header: "Timestamp",
    cell: ({ getValue }) => formatDateTime(getValue(), "MM/dd/yyyy", browserTimezone),
  }),
  columnHelper.accessor("note", { header: "Note" }),
];

type ProNotesTableProps = { proId: number };

export const ProNotesTable = ({ proId }: ProNotesTableProps) => {
  const { data: notes = [], isLoading } = useQuery(notesQuery({ proId }));

  return <DataTable columns={columns} data={notes} loading={isLoading} />;
};
